<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- ⚜️ ELEMENTOS DE ESQUINA DECORATIVOS -->
    <img
      src="@/assets/esq1.png"
      ref="elemTLRef"
      class="esquina esquina-tl"
      alt=""
    />
    <img
      src="@/assets/esq1.png"
      ref="elemBRRef"
      class="esquina esquina-br"
      alt=""
    />

    <!-- 🦋 MARIPOSAS ANIMADAS (ALETEO FINO EN SU LUGAR) -->
    <img
      :src="mariposaImg"
      ref="mariposa1Ref"
      class="mariposa-fija mariposa-1"
      alt=""
    />

    <!-- SECCIÓN DAMAS -->
    <section class="texto-xv">
      <div class="titulo-damas-container" ref="quinceaneraTitleRef">
        <img :src="mariposaImg" ref="mariposaTituloIzq" class="mariposa-titulo" alt="" />
        <h2 class="honor-texto">My Court of Honor</h2>
        <img :src="mariposaImg" ref="mariposaTituloDer" class="mariposa-titulo espejo" alt="" />
      </div>

      <div class="separador-elegante"></div>

      <ul class="lista-damas" ref="acompanaRef">
        <li>Aanya Alapati</li>
       
        <li>Annabel Zhang</li>
                <li> Britanny Rivas</li>

        <li>Crystal He</li>
        <li>Elina Mittal</li>
        <li>Isabella Assad</li>
        <li>Sia Prakash</li>
        <li>Yizhen Li</li>
      </ul>
    </section>

    <!-- 🎀 MOÑO AL FINAL (ABAJO DE TODO) -->
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

// Importar la imagen de la mariposa
import mariposaImg from '@/assets/mariposa.png'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)
    const fotoPortadaRef = ref(null)
    const mascaraRef = ref(null)
    const acompanaRef = ref(null)
    const quinceaneraTitleRef = ref(null)
    const deRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    
    // Referencias Esquinas Decorativas
    const elemTLRef = ref(null) // Top Left (elemento3)
    const florTRRef = ref(null) // Top Right
    const florBLRef = ref(null) // Bottom Left
    const elemBRRef = ref(null) // Bottom Right (elemento3)

    // Referencias directas a las mariposas
    const mariposa1Ref = ref(null)
    const mariposa2Ref = ref(null)
    const mariposaTituloIzq = ref(null)
    const mariposaTituloDer = ref(null)

    onMounted(() => {
      // ---------------------------------------------------------
      // 0. ESTADO INICIAL
      // ---------------------------------------------------------
      gsap.set(mascaraRef.value, { opacity: 0, scale: 0.5, y: -20 })

      // Agrupamos las referencias para el clipPath inicial
      const todasLasEsquinas = [elemTLRef.value, florTRRef.value, florBLRef.value, elemBRRef.value].filter(Boolean)
      
      // Estado inicial para esquinas (ocultas y clipPath en 0)
      gsap.set(todasLasEsquinas, {
        opacity: 0,
        clipPath: 'polygon(0% 0%, 0% 0%, 0% 0%, 0% 0%)'
      })

      // Estado inicial de mariposas (visibles con perspectiva 3D sutil)
      gsap.set([mariposa1Ref.value, mariposa2Ref.value, mariposaTituloIzq.value, mariposaTituloDer.value], {
        opacity: 0,
        transformPerspective: 800,
        transformOrigin: "center center"
      })

      // ---------------------------------------------------------
      // 1. ANIMACIÓN DE ENTRADA PRINCIPAL
      // ---------------------------------------------------------
      if (fotoPortadaRef.value) {
        gsap.from(fotoPortadaRef.value, { opacity: 0, y: 50, duration: 1.2, ease: 'power3.out' })
      }
      
      const tl = gsap.timeline({ delay: 0.4 })
      
      // Animamos el clipPath para las esquinas
      tl.to(todasLasEsquinas, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1.6,
        ease: 'power2.inOut'
      })
      .to([elemTLRef.value, elemBRRef.value].filter(Boolean), {
        opacity: 0.85,
        duration: 1.6,
        ease: 'power2.inOut'
      }, "<")
      .to([florTRRef.value, florBLRef.value].filter(Boolean), {
        opacity: 0.25,
        duration: 1.6,
        ease: 'power2.inOut'
      }, "<")
      
      // Entrada sutil y suave de las mariposas principales
      .to([mariposa1Ref.value, mariposa2Ref.value], {
        opacity: 0.85,
        duration: 1.4,
        ease: 'power2.out'
      }, "-=1.2")

      // Continuamos con el resto del contenido
      .to(mascaraRef.value, { opacity: 1, scale: 1, y: 0, duration: 1, ease: 'back.out(1.7)' }, "-=1")
      .from([quinceaneraTitleRef.value, acompanaRef.value].filter(Boolean), { opacity: 0, y: 25, duration: 0.8, stagger: 0.15, ease: 'power2.out' }, "-=0.4")
      
      // Aparición suave de las mariposas del título
      .to([mariposaTituloIzq.value, mariposaTituloDer.value], {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out'
      }, "-=0.4")

      // ---------------------------------------------------------
      // 🦋 2. ANIMACIÓN DE ALETEO SÚPER FINO, DELICADO Y PAUSADO
      // ---------------------------------------------------------
      
      // Mariposa 1: Aleteo sutil y orgánico + Flotación flotante delicada
      gsap.to(mariposa1Ref.value, {
        rotateY: 15,
        scaleX: 0.8,
        duration: 0.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
      gsap.to(mariposa1Ref.value, {
        y: '-=3',
        x: '+=3',
        rotation: '-=2',
        duration: 0.9,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      // Mariposa 2: Ritmo pausado desfasado + Briso flotante
      gsap.to(mariposa2Ref.value, {
        rotateY: -25,
        scaleX: 0.9,
        duration: 0.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.4
      })
      gsap.to(mariposa2Ref.value, {
        y: '+=7',
        x: '-=4',
        rotation: '+=2.5',
        duration: 4.0,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      // 🦋 Mariposa Izquierda del Título: Aleteo delicado
      gsap.to(mariposaTituloIzq.value, {
        rotateY: 30,
        scaleX: 0.85,
        duration: 0.6,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
      gsap.to(mariposaTituloIzq.value, {
        y: '-=4',
        rotation: '-=3',
        duration: 1.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      // 🦋 Mariposa Derecha del Título: Aleteo simétrico y desfasado
      gsap.to(mariposaTituloDer.value, {
        rotateY: -30,
        scaleX: 0.85,
        duration: 0.6,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.2
      })
      gsap.to(mariposaTituloDer.value, {
        y: '-=4',
        rotation: '+=3',
        duration: 2.0,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
    })

    return {
      rootRef,
      fotoPortadaRef, mascaraRef, acompanaRef, quinceaneraTitleRef,
      deRef, nombreRef, fechaRef, mariposa1Ref, mariposa2Ref,
      mariposaTituloIzq, mariposaTituloDer,
      elemTLRef, florTRRef, florBLRef, elemBRRef,
      mariposaImg
    }
  }
}
</script>

<style scoped>
.portada-xv {
  position: relative;
  width: 100%;
  min-height: 50vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: radial-gradient(circle at center, #6d0a14 0%, #3e0409 100%);
  padding: 48px 16px 56px;
}

@media (max-width: 768px) {
  .portada-xv {
    background-attachment: scroll;
  }
}

/* ⚜️ ESQUINAS DECORATIVAS */
.esquina {
  position: absolute;
  width: min(40vw, 180px);
  height: auto;
  pointer-events: none;
  z-index: 5;
}

/* Superior Izquierda */
.esquina-tl {
  top: 0;
  left: 0;
}

/* Inferior Derecha (Invertida) */
.esquina-br {
  bottom: 0;
  right: 0;
  transform: scaleX(-1) scaleY(-1);
}

/* 🦋 MARIPOSAS FIJAS CON ALETEO */
.mariposa-fija {
  position: absolute;
  width: min(14vw, 55px);
  height: auto;
  pointer-events: none;
  z-index: 6;
  transform-style: preserve-3d;
  will-change: transform;
}

.mariposa-1 {
  top: 42%;
  right: 10%;
  transform: rotate(-15deg);
}

.mariposa-2 {
  bottom: 4%;
  left: 8%;
  transform: rotate(18deg);
}

/* MARCO Y FOTO */
.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 20px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background: #fff;
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.18),
    0 2px 8px rgba(0, 0, 0, 0.06);
  will-change: transform, filter, opacity;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* TEXTOS Y DAMAS */
.texto-xv {
  max-width: 620px;
  text-align: center;
  margin-top: 22px;
  padding: 0 8px;
  z-index: 2;
}

.titulo-damas-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
}

.mariposa-titulo {
  width: 28px;
  height: auto;
  transform-style: preserve-3d;
  will-change: transform;
}

.mariposa-titulo.espejo {
  transform: scaleX(-1);
}

.separador-elegante {
  width: 110px;
  height: 2px;
  margin: 12px auto 20px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}

.lista-damas {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lista-damas li {
  font: clamp(1.1rem, 4vw, 1.3rem) 'quote', sans-serif;
  color: #B28F60;
  letter-spacing: 0.5px;
}

.honor-texto {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: clamp(2rem, 8vw, 2.4rem);
  display: block;
  line-height: 1.1;
  color: #fafafa;
  margin: 0;
}

/* 🎀 MOÑO INFERIOR */
.monio-inferior {
  width: min(45vw, 180px);
  height: auto;
  margin-top: 24px;
  display: block;
  z-index: 2;
  pointer-events: none;
}

@media (min-width: 992px) {
  .portada-xv {
    padding-top: 64px;
  }
  .imagen-xv-wrapper {
    margin-top: 0;
  }
}
</style>